<template>
	<dl class="track-info">
		<div v-if="trackInfo == 'load'" class="loading-animation"><div class="box"><span></span></div></div>
		<template v-else-if="trackInfo.length">
			<dd v-for="(obj, index) in trackInfo" class="clear">
				<a class="pic" :href="obj.detail_url_recommend" target="_blank" :title="obj.title">
					<img :src="obj.pic_url" :alt="obj.title">
				</a>
				<div class="content">
					<a class="title" :href="obj.detail_url_recommend" target="_blank" :title="obj.title">{{ obj.title }}</a>
				</div>
				<div class="right-box">
					<p class="price">￥{{ obj.price }}</p>
				</div>
			</dd>
		</template>
		<p v-else class="shift">没有相关数据！</p>
	</dl>
</template>

<script>
export default {
	name: 'trackInfoTpl',
	data () {
		return {}
	},
	computed: {
		trackInfo () {
			return this.$store.state.trackInfo;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/wwTrackInfo.vue